<template>
  <div class="confirm-base-content">
    <div class="header">
      <i class="q-icon"><a-icon type="question-circle"/></i>
        <span class="confirm-title">{{title}}</span>
    </div>
    <div class="confirm-content">
      {{content}}
    </div>
    <div class="confirm-btns">
      <a-button @click="onclickCancel">{{cancelTxt}}</a-button>
      <a-button @click="onclickOk" style="margin-left: 8px;" type="danger">{{okTxt}}</a-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return this.$t('edit.editMessage.title')
      }
    },
    content: {
      type: String,
      required: true,
    },
    cancelTxt: {
      type: String,
      required: true,
    },
    okTxt: {
      type: String,
      required: true,
    }
  },
  methods: {
    onclickCancel() {
      this.$emit("onclickCancel")
    },
    onclickOk() {
      this.$emit("onclickOk")
    }
  }
};
</script>

<style lang="less" scoped>
.confirm-base-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 4px;
  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .q-icon {
      color: #faad14;
      font-size: 22px;
      margin-right: 16px;
    }
    .confirm-title {
      display: block;
      overflow: hidden;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      font-size: 16px;
      line-height: 1.4;
    }
  }
  .confirm-content {
    padding: 8px 0 0 38px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
  .confirm-btns {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 24px;
  }
}

</style>